import * as React from "react"
const CardEmailIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.161}
    height={9.87}
    viewBox="0 0 3.747 2.611"
    {...props}
  >
    <path
      d="M2.167 1.548h-.008a.062.062 0 0 0-.042.074.062.062 0 0 0 .058.045h.024a.062.062 0 0 0 .042-.074.058.058 0 0 0-.072-.043z"
      className="cls-4"
    />
    <path
      d="M3.746 1.397a.116.116 0 0 0-.068-.077l-.36-.153a.103.103 0 0 0-.125.034c-.015.021-.02.05-.015.074l.06.228-2.709.73-.037.01A.295.295 0 0 1 .32 1.68v.405c0 .032.027.058.058.058a.059.059 0 0 0 .058-.058V.55l1.247.746c.14.085.315.082.455 0l1.185-.72v.443c0 .031.027.058.058.058a.059.059 0 0 0 .058-.058V.374A.375.375 0 0 0 3.064 0H.694a.375.375 0 0 0-.377.373V1.563h-.01a.433.433 0 0 0-.252.196.416.416 0 0 0-.042.313.415.415 0 0 0 .33.301.374.374 0 0 0 .35.238h2.37a.375.375 0 0 0 .376-.373v-.206a.059.059 0 0 0-.058-.058.059.059 0 0 0-.058.058v.206c0 .14-.116.257-.257.257H.696a.26.26 0 0 1-.217-.116c.016 0 .029-.006.045-.011l.037-.01 2.71-.73.044.169a.092.092 0 0 0 .05.058.103.103 0 0 0 .125-.035l.233-.312c.02-.029.029-.066.02-.098zM.436.413V.365c0-.14.117-.257.257-.257h2.37c.144 0 .257.114.257.257v.069l-1.246.757a.317.317 0 0 1-.33 0L.436.41zm2.982 1.296-.113-.418.322.138z"
      className="cls-4"
    />
    <path
      d="M1.87 1.627h-.007a.062.062 0 0 0-.043.074.062.062 0 0 0 .058.045h.024a.062.062 0 0 0 .043-.074.058.058 0 0 0-.072-.042zM2.931 1.863l-.764.203a.058.058 0 0 0-.042.072.062.062 0 0 0 .058.045h.016l.764-.204a.058.058 0 0 0 .043-.071.058.058 0 0 0-.072-.043zM2.931 1.344l-.534.143a.058.058 0 0 0-.042.071.062.062 0 0 0 .058.045h.016l.534-.142a.058.058 0 0 0 .043-.072.058.058 0 0 0-.072-.042zM1.94 2.13H1.93a.062.062 0 0 0-.042.074.062.062 0 0 0 .058.045h.024a.062.062 0 0 0 .042-.074.058.058 0 0 0-.071-.042z"
      className="cls-4"
    />
  </svg>
)
export default CardEmailIcon
